export class NextVaccination {
    _id: string;
    name: string;
    drug: string;
    date: string;
}
